import { createFileRoute } from '@tanstack/react-router';

import { NewPatientPage } from '@/features/emr/pages/NewPatientPage';

export const Route = createFileRoute('/_authenticated/patients/new')({
  component: NewPatientPage,
  beforeLoad: () => ({
    breadcrumbs: [
      { href: '/patients', title: 'Patients' },
      { title: 'New Patient', href: '/patients/new' },
    ],
  }),
});
